import { combineReducers } from '@reduxjs/toolkit';

import formReducer from './form/slice/formSlice';

const insumoProveedorReducer = combineReducers({
  form: formReducer,
});

export default insumoProveedorReducer;
